import '../scss/milo.scss';

// Modules
import './modules/search';

// Vendor
import './vendor/bootstrap';
import './vendor/font-awesome';
import './vendor/timeago';

document.addEventListener("DOMContentLoaded", function() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});